export const FolderPermissionModel = Symbol.for('FolderPermissionModel');
